import { Component, h } from 'preact'
import Header from '../header'
import Axios from 'axios'
import AlertComponent from '../ui-components/AlertComponent'
import InputGroup from '../ui-components/InputGroup'

type Alert = {
  message?: string,
  type: 'success' | 'error'
}

interface Props {
    destinationURL: string
}

interface State {
    destinationURL: string,
    alert: Alert | null
}

class CommunityConfiguration extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      destinationURL: props.destinationURL,
      alert: null
    }
  }

   onSave = async () => {
     const { destinationURL } = this.state
     try {
       await Axios.post('/community/settings/save', {
         destinationURL
       })

       this.setState({ alert: { type: 'success', message: 'Community settings successfully saved!' } })
     } catch (err) {
       this.setState({ alert: { type: 'error', message: err.response.data } })
     }
   }

   render (_: Props, { destinationURL, alert }: State) {
     return (
       <div className='community-settings-page'>
         <Header
           title='Community Settings'
           hasBreadcrumb={false}
           saveCallback={this.onSave}
         />
         {alert &&
         <AlertComponent sticky isVisible message={alert.message} messageType={alert.type} isVisibleFor={5000}
           onTimeoutEnd={() => this.setState({ alert: null })} />}
         <div className='community-settings'>
           <InputGroup
             title='Destination URL'
             type='text'
             onChange={(e: { target: HTMLInputElement }) => this.setState({ destinationURL: e.target.value })}
             meta='Change the destination URL for this community below.'
             value={destinationURL}
             placeholder='https://community.example.com'
             required
             qaClasses='destination-url-input'
           />
         </div>
       </div>
     )
   }
}

export default CommunityConfiguration
